import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {  Grid, Link, InputLabel, Select, MenuItem, FormControl } from "@mui/material";
import {
  Unstable_NumberInput as BaseNumberInput,
  NumberInputProps,
} from '@mui/base/Unstable_NumberInput';
import { styled } from '@mui/system';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';



import Button from 'react-bootstrap/Button';
import NumericInput from "react-numeric-input";
import { useState } from "react";


const NumberInput = React.forwardRef(function CustomNumberInput(
  props,ref
) {
  return (
    <BaseNumberInput
      slots={{
        root: StyledInputRoot,
        input: StyledInput,
        incrementButton: StyledButton,
        decrementButton: StyledButton,
      }}
      slotProps={{
        incrementButton: {
          children: <AddIcon fontSize="small" />,
          className: 'increment',
        },
        decrementButton: {
          children: <RemoveIcon fontSize="small" />,
        },
      }}
      {...props}
      ref={ref}
    />
  );
});




const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop:'30px',
  marginBottom:'30px',

  borderRadius:3,
  transform: "translate(-50%, -50%)",
  width:'1000px',
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  maxHeight: '100vh',
  p: 4,
  overflowY: "auto"
};

const blue = {
  100: '#daecff',
  200: '#b6daff',
  300: '#66b2ff',
  400: '#3399ff',
  500: '#007fff',
  600: '#0072e5',
  700: '#0059B2',
  800: '#004c99',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};



export default function BasicModal({ onOpen, onClose, open, row }) {
  const [emailInput, setEmailInput] = useState(row.marketRent);
  const [streetInput, setStreetInput] = useState(row.purchasePrice);
  const [stateInput, setStateInput] = useState(row.interestRate);
  const [zipInput, setZipInput] = useState(row.term);
  const [phoneNumberInput, setPhoneNumberInput] = useState(row.currentRent);
  const [cityInput, setCityInput] = useState(row.totalDownPayment);
  const [firstNameInput, setFirstNameInput] = useState(row.propertyName);
  const [lastNameInput, setLastNameInput] = useState(row.nickname);
  const [monthlyMaintainenceReservation, setMonthlyMaintainenceReservation] = useState(0);
  const [monthlyVacancyReserve, setMonthlyVacancyReserve] = useState(0);
  const [monthlyUtilities, setMonthlyUtilities] = useState(0);


///////////PROPERTY TAXES///////////////////

let propertyTaxOperatingCost = Math.round(row.purchasePrice * .000925)
let insuranceOperatingCost = Math.round(row.purchasePrice * .000833)


///////////PROPERTY TAXES///////////////////

/////////////PROPERTY MANAGEMENT//////////
const totalPropManagement = row.currentRent *.1
const potentialTotalPropManagement = row.marketRent *.1

/////////////PROPERTY MANAGEMENT//////////

  //////////MORTGAGE CALCULATOR ////////////////

  
  var M; //monthly mortgage payment
  var P = row.purchasePrice -row.downPayment; //principle / initial amount borrowed
  var I = row.interestRate / 100 / 12; //monthly interest rate
  var N = row.term * 12; //number of payments months  

  function monthlyPayment(p, n, i) {
    return p * i * (Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
  }

  M = monthlyPayment(P, N, I);
  




  //////////MORTGAGE CALCULATOR ////////////////

////////TOTAL MONTHLY EXPENSE//////////////
let totalMonthlyExpense = (totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation+Math.round(monthlyPayment(P,N,I)))
let potentialTotalMonthlyExpense = (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation+Math.round(monthlyPayment(P,N,I)))
console.log(totalMonthlyExpense)

console.log('TME',totalMonthlyExpense )


  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
       <Box sx={style}>
      
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
         
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
           Address
          <input
                                                      value={firstNameInput} onChange={(e) => { setFirstNameInput(e.target.value) }}

                              type="text"
                              required
                              className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                          />
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
            Property Nickname
          <input
                                          value={lastNameInput} onChange={(e) => { setLastNameInput(e.target.value) }}

                              type="text"
                              required
                              className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                          />
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
            Current Rent
          <input
                                          value={phoneNumberInput} onChange={(e) => { setPhoneNumberInput(e.target.value) }}

                              type="text"
                              required
                              className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                          />
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
          Market Rent
          <input
                              type="text"
                              required
                              value={emailInput} onChange={(e) => { setEmailInput(e.target.value) }}

                              className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                          />
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="body1" component="h2">
          {/* {row.firstName} {row.lastName}           */}
          </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="body1" component="h2">
          {/* {row.email}  */}
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
Purchase Price            <input
          value={streetInput} onChange={(e) => { setStreetInput(e.target.value) }}
                              type="text"
                              required
                              className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                          />
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" sx={{ fontWeight: 'bold'}} variant="h6" component="h2">
          Down Payment
          <input
          value={cityInput} onChange={(e) => { setCityInput(e.target.value) }}
                              type="text"
                              required
                              className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                          />
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
          Interest Rate
          <input
          value={stateInput} onChange={(e) => { setStateInput(e.target.value) }}
                              type="text"
                              required
                              className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                          />
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" sx={{ fontWeight: 'bold'}} variant="h6" component="h2">
          Term (yrs)
          <input
          value={zipInput} onChange={(e) => { setZipInput(e.target.value) }}
                              type="text"
                              required
                              className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                          />
        </Typography>
        
          </Grid>
          
      {/* <SwiperSlide >
          <img
            src={"https://i.ibb.co/xKby3CK/abandoned-old-wood-plank-farm-house-very-bad-condition-149482664.webp"}
            alt={"house"}
            className="swiper-image"
          />
        </SwiperSlide> */}
        {/* <ModalListing /> */}
      
        <Typography align="center"   variant="h5" component="h4" sx={{ fontWeight: 'bold', marginLeft:'27%', marginTop:'20px', marginBottom:'20px' }}>
             Current Financials (Monthly)
           </Typography>
        
        <Grid container rowSpacing={8} spacing={{ xs: 4, md: 4 }} columns={{ xs: 4, sm: 8, md: 12 }} >
           
            <Grid item xs={2} sm={4} md={4}>
            <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Mgmt</h3>
              <h3 align={'center'}>${totalPropManagement}</h3>
              

          </Typography>
          <Grid item xs={2} sx={{mb:4}} align={'center'} >
            </Grid>
            <Typography 
              id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Utilities</h3>
              <NumberInput aria-label="Quantity Input"  style={{marginBottom:'10px'}} min={1} max={100000}   value={monthlyUtilities}
    onChange={(event, val) => setMonthlyUtilities(val)}

/>
          </Typography>
          <Grid item xs={2} sx={{mb:4}} align={'center'} >
            </Grid>
            
            
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
            <Typography sx={{ border: 1, borderRadius:'5px' }} id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Taxes</h3>
              <h3 align={'center'}>${(row.purchasePrice * .000925)}</h3>
              
          </Typography>
          <Grid item xs={2} align={'center'}sx={{mb:4}}>
            {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
            </Grid>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Vacancy Reserve</h3>
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={monthlyVacancyReserve}
    onChange={(event, val) => setMonthlyVacancyReserve(val)}

/>
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
            </Grid>
            
           
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
            <Typography sx={{ border: 1, borderRadius:'5px' }} id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Insurance</h3>
              <h3 align={'center'}>${(row.purchasePrice * .000833)}</h3>
              
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
            
            </Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Maintenance Reserve</h3>
              <NumberInput style={{marginBottom:'10px'}} aria-label="Quantity Input" min={1} max={100000}   value={monthlyMaintainenceReservation}
    onChange={(event, val) => setMonthlyMaintainenceReservation(val)}

/>
          </Typography>
          <Grid item xs={2} align={'center'} >
            </Grid>
            
            </Grid>
           
            
            
            
          </Grid>

          <Grid container rowSpacing={8} spacing={{ xs: 4, md: 4 }} columns={{ xs: 4, sm: 8, md: 12 }} >
           
           <Grid item xs={2} sm={4} md={4}>
           <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Gross Rent</h3>
             {/* <NumberInput aria-label="Quantity Input" min={1} max={99} /> */}
             <div align={'center'} >${row.currentRent}</div>
         </Typography>
         <Grid item xs={2} sx={{mb:4}} align={'center'} >
           {/* <NumericInput mobile  min={0} max={1000000} value={0} step={0.1} precision={2}/> */}
           </Grid>
           <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Annual NOI</h3>
             <div align={'center'} >${(row.currentRent - (totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+row.monthlyMaintainenceReservation))*12}</div>
           
         </Typography>
         <Grid item xs={2} sx={{mb:4}} align={'center'} >
           {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
           </Grid>
           <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Monthly Cashflow</h3>
             <div align={'center'} >${row.currentRent - totalMonthlyExpense}</div>
           
         </Typography>
         <Grid item xs={2} sx={{mb:4}} align={'center'} >
           {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
           </Grid>
           
           
           </Grid>
           <Grid item xs={2} sm={4} md={4}>
           <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Total Oper. Expenses</h3>
             <div align={'center'} >${totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+row.monthlyMaintainenceReservation}</div>
         </Typography>
         <Grid item xs={2} align={'center'}sx={{mb:4}}>
           {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
           </Grid>
           <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Cap Rate</h3>
             <div align={'center'} >{((((row.currentRent - (totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+row.monthlyMaintainenceReservation))*12)/row.purchasePrice)*100).toFixed(2)}%</div>
         </Typography>
         <Grid item xs={2} align={'center'}sx={{mb:4}}>
           {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
           </Grid>
           <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Annual Cashflow</h3>
             <div align={'center'} >${(row.currentRent - totalMonthlyExpense)*12}</div>
         </Typography>
         <Grid item xs={2} align={'center'} sx={{mb:4}}>
           </Grid>
           
          
           </Grid>
           <Grid item xs={2} sm={4} md={4}>
           <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Monthly NOI</h3>
             <div align={'center'} >${row.currentRent - (totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+row.monthlyMaintainenceReservation) }</div>
           
         </Typography>
         <Grid item xs={2} align={'center'} sx={{mb:4}}>
          
           </Grid>
           <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Mortgage Calculation</h3>
             <div align={'center'} >${Math.round(monthlyPayment(P,N,I))}</div>
         </Typography>
         <Grid item xs={2} align={'center'} sx={{mb:4}}>
          
           </Grid>
           <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Annualized ROI</h3>
             <div align={'center'} >{(100*(((row.currentRent - totalMonthlyExpense)*12)/row.purchasePrice)).toFixed(2)}%</div>
         </Typography>
         <Grid item xs={2} align={'center'} >
           </Grid>
           
           </Grid>
         
           
           
           
         </Grid>





        <Typography align="center"   variant="h5" component="h4" sx={{ fontWeight: 'bold', marginLeft:'27%', marginTop:'20px', marginBottom:'20px' }}>
           Potential Financials (Monthly)
         </Typography>
      
         <Grid container rowSpacing={8} spacing={{ xs: 4, md: 4 }} columns={{ xs: 4, sm: 8, md: 12 }} >
           
           <Grid item xs={2} sm={4} md={4}>
           <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Mgmt</h3>
             <h3 align={'center'}>${potentialTotalPropManagement}</h3>
             

         </Typography>
         <Grid item xs={2} sx={{mb:4}} align={'center'} >
           </Grid>
           <Typography 
             id="modal-modal-title" variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Utilities</h3>
             <NumberInput aria-label="Quantity Input"  style={{marginBottom:'10px'}} min={1} max={100000}   value={monthlyUtilities}
   onChange={(event, val) => setMonthlyUtilities(val)}

/>
         </Typography>
         <Grid item xs={2} sx={{mb:4}} align={'center'} >
           </Grid>
           
           
           </Grid>
           <Grid item xs={2} sm={4} md={4}>
           <Typography sx={{ border: 1, borderRadius:'5px' }} id="modal-modal-title" variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Taxes</h3>
             <h3 align={'center'}>${(row.purchasePrice * .000925)}</h3>
             
         </Typography>
         <Grid item xs={2} align={'center'}sx={{mb:4}}>
           {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
           </Grid>
           <Typography  id="modal-modal-title" variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Vacancy Reserve</h3>
             <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={monthlyVacancyReserve}
   onChange={(event, val) => setMonthlyVacancyReserve(val)}

/>
         </Typography>
         <Grid item xs={2} align={'center'} sx={{mb:4}}>
           </Grid>
           
          
           </Grid>
           <Grid item xs={2} sm={4} md={4}>
           <Typography sx={{ border: 1, borderRadius:'5px' }} id="modal-modal-title" variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Insurance</h3>
             <h3 align={'center'}>${(row.purchasePrice * .000833)}</h3>
             
         </Typography>
         <Grid item xs={2} align={'center'} sx={{mb:4}}>
           
           </Grid>
           <Typography id="modal-modal-title" variant="h6" component="h2" >
             <h3 align={'center'} style={{fontWeight:'bold'}}>Maintenance Reserve</h3>
             <NumberInput style={{marginBottom:'10px'}} aria-label="Quantity Input" min={1} max={100000}   value={monthlyMaintainenceReservation}
   onChange={(event, val) => setMonthlyMaintainenceReservation(val)}

/>
         </Typography>
         
           
           </Grid>
           
          
           
           
           
         </Grid>
         <Grid container rowSpacing={8} spacing={{ xs: 4, md: 4 }} columns={{ xs: 4, sm: 8, md: 12 }} >
           
            <Grid item xs={2} sm={4} md={4}>
            <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Gross Rent</h3>
              {/* <NumberInput aria-label="Quantity Input" min={1} max={99} /> */}
              <div align={'center'} >${row.marketRent}</div>
          </Typography>
          <Grid item xs={2} sx={{mb:4}} align={'center'} >
            {/* <NumericInput mobile  min={0} max={1000000} value={0} step={0.1} precision={2}/> */}
            </Grid>
            <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Annual NOI</h3>
              <div align={'center'} >${(row.marketRent - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation))*12}</div>
            
          </Typography>
          <Grid item xs={2} sx={{mb:4}} align={'center'} >
            {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
            </Grid>
            <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Monthly Cashflow</h3>
              <div align={'center'} >${row.marketRent - potentialTotalMonthlyExpense}</div>
            
          </Typography>
          <Grid item xs={2} sx={{mb:4}} align={'center'} >
            {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
            </Grid>
            
            
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
            <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Total Oper. Expenses</h3>
              <div align={'center'} >${potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation}</div>
          </Typography>
          <Grid item xs={2} align={'center'}sx={{mb:4}}>
            {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
            </Grid>
            <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Cap Rate</h3>
              <div align={'center'} >{((((row.marketRent - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation))*12)/row.purchasePrice)*100).toFixed(2)}%</div>
          </Typography>
          <Grid item xs={2} align={'center'}sx={{mb:4}}>
            {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
            </Grid>
            <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Annual Cashflow</h3>
              <div align={'center'} >${(row.marketRent - potentialTotalMonthlyExpense)*12}</div>
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
            </Grid>
            
           
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
            <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Monthly NOI</h3>
              <div align={'center'} >${row.marketRent - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation) }</div>
            
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
           
            </Grid>
            <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Mortgage Calculation</h3>
              <div align={'center'} >${Math.round(monthlyPayment(P,N,I))}</div>
          </Typography>
          <Grid item xs={2} align={'center'} sx={{mb:4}}>
           
            </Grid>
            <Typography id="modal-modal-title" sx={{ border: 1, borderRadius:'5px' }} variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Annualized ROI</h3>
              <div align={'center'} >{(100*(((row.marketRent - potentialTotalMonthlyExpense)*12)/row.purchasePrice)).toFixed(2)}%</div>
          </Typography>
          <Grid item xs={2} align={'center'} >
            </Grid>
            
            </Grid>
          
            
            
            
          </Grid>

      
        
      
     


          <div style={
{marginLeft:'28.5%', 


          }}> 
<button onClick={console.log('added')} class="bg-transparent hover:bg-green-500 text-green-700 font-semibold hover:text-white py-2 px-4 border border-green-500 hover:border-transparent rounded">
Update Property
</button>
<button onClick={console.log('added')} class="bg-transparent hover:bg-red-500 text-red-700 font-semibold hover:text-white py-2 px-4 ml-4 border border-red-500 hover:border-transparent rounded">
Delete Property
</button>
</div>

          
          
        
          
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="body1" component="h2">
          {/* {row.street} */}
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="body1" component="h2">
          {/* {row.permission} */}
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="body1" component="h2">
          {/* {row.city} */}
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
         
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="body1" component="h2">
          {/* {row.livingState} */}
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
         
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="body1" component="h2">
          {/* {row.zip} */}
        </Typography>
          </Grid>
          <Grid item xs={6}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
        </Typography>
          </Grid>


          
          <Grid item xs={6} >
          <Typography id="modal-modal-title" variant="body1" component="h2">
                
          </Typography>
          </Grid>
          
          <Grid item xs={6}>
                
          </Grid>
          <Grid item xs={6}>
                
          </Grid>
         
          
        
          
          
        </Grid>
        
          
        
    


<div>

    </div>
      </Box>
      
        
      </Modal>
    </div>
  );
}

const StyledInputRoot = styled('div')(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 400;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[500]};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`,
);

const StyledInput = styled('input')(
  ({ theme }) => `
  font-size: 0.875rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.375;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0 2px 4px ${
    theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
  };
  border-radius: 8px;
  margin: 0 8px;
  padding: 10px 12px;
  outline: 0;
  min-width: 0;
  width: 4rem;
  text-align: center;

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[700] : blue[200]};
  }

  &:focus-visible {
    outline: 0;
  }
`,
);



const StyledButton = styled('button')(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  line-height: 1.5;
  border: 1px solid;
  border-radius: 999px;
  border-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
  color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
  width: 32px;
  height: 32px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;

  &:hover {
    cursor: pointer;
    background: ${theme.palette.mode === 'dark' ? blue[700] : blue[500]};
    border-color: ${theme.palette.mode === 'dark' ? blue[500] : blue[400]};
    color: ${grey[50]};
  }

  &:focus-visible {
    outline: 0;
  }

  &.increment {
    order: 1;
  }
`,
);